import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  AvatarComponent,
  BadgeComponent,
  BreadcrumbRouterComponent,
  ColorModeService,
  ContainerComponent,
  DropdownComponent,
  DropdownDividerDirective,
  DropdownHeaderDirective,
  DropdownItemDirective,
  DropdownMenuDirective,
  DropdownToggleDirective,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  NavItemComponent,
  NavLinkDirective,
  ProgressBarDirective,
  ProgressComponent,
  SidebarToggleDirective,
  TextColorDirective,
  ThemeDirective
} from '@coreui/angular-pro';

import { IconDirective } from '@coreui/icons-angular';
import { Router } from '@angular/router';
import { AutoavatarComponent } from '../../../views/base/autoavatar/autoavatar.component';
import { BaseService } from '../../../base.service';
import { FormsModule } from '@angular/forms';
import { AdminSettingsService } from '../../../views/cruds/admin-settings/admin-settings.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
  standalone: true,
  imports: [ContainerComponent,AutoavatarComponent, HeaderTogglerDirective, SidebarToggleDirective, IconDirective, HeaderNavComponent, NavItemComponent, NavLinkDirective, RouterLink, RouterLinkActive, NgTemplateOutlet, BreadcrumbRouterComponent, ThemeDirective, DropdownComponent, DropdownToggleDirective, TextColorDirective, AvatarComponent, DropdownMenuDirective, DropdownHeaderDirective, DropdownItemDirective, BadgeComponent, DropdownDividerDirective, ProgressBarDirective, ProgressComponent, NgClass, NgStyle, FormsModule]
})
export class DefaultHeaderComponent extends HeaderComponent {

  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  readonly colorModes = [
    { name: 'light', text: 'Light', icon: 'cilSun' },
    { name: 'dark', text: 'Dark', icon: 'cilMoon' },
    { name: 'auto', text: 'Auto', icon: 'cilContrast' }
  ];

  readonly icons = computed(() => {
    const currentMode = this.colorMode();
    return this.colorModes.find(mode => mode.name === currentMode)?.icon ?? 'cilSun';
  });

  constructor (
    private router: Router,
    private baseService: BaseService,
    private adminSettings: AdminSettingsService
  ) {
    super();
  }

  sidebarId = input('sidebar1');

  public newMessages = [
    {
      id: 0,
      from: 'Jessica Williams',
      avatar: '7.jpg',
      status: 'success',
      title: 'Urgent: System Maintenance Tonight',
      time: 'Just now',
      link: 'apps/email/inbox/message',
      message: 'Attention team, we\'ll be conducting critical system maintenance tonight from 10 PM to 2 AM. Plan accordingly...'
    },
    {
      id: 1,
      from: 'Richard Johnson',
      avatar: '6.jpg',
      status: 'warning',
      title: 'Project Update: Milestone Achieved',
      time: '5 minutes ago',
      link: 'apps/email/inbox/message',
      message: 'Kudos on hitting sales targets last quarter! Let\'s keep the momentum. New goals, new victories ahead...'
    },
    {
      id: 2,
      from: 'Angela Rodriguez',
      avatar: '5.jpg',
      status: 'danger',
      title: 'Social Media Campaign Launch',
      time: '1:52 PM',
      link: 'apps/email/inbox/message',
      message: 'Exciting news! Our new social media campaign goes live tomorrow. Brace yourselves for engagement...'
    },
    {
      id: 3,
      from: 'Jane Lewis',
      avatar: '4.jpg',
      status: 'info',
      title: 'Inventory Checkpoint',
      time: '4:03 AM',
      link: 'apps/email/inbox/message',
      message: 'Team, it\'s time for our monthly inventory check. Accurate counts ensure smooth operations. Let\'s nail it...'
    },
    {
      id: 4,
      from: 'Ryan Miller',
      avatar: '4.jpg',
      status: 'info',
      title: 'Customer Feedback Results',
      time: '3 days ago',
      link: 'apps/email/inbox/message',
      message: 'Our latest customer feedback is in. Let\'s analyze and discuss improvements for an even better service...'
    }
  ];

  public newNotifications = [
    { id: 0, title: 'New user registered', icon: 'cilUserFollow', color: 'success' },
    { id: 1, title: 'User deleted', icon: 'cilUserUnfollow', color: 'danger' },
    { id: 2, title: 'Sales report is ready', icon: 'cilChartPie', color: 'info' },
    { id: 3, title: 'New client', icon: 'cilBasket', color: 'primary' },
    { id: 4, title: 'Server overloaded', icon: 'cilSpeedometer', color: 'warning' }
  ];

  public newStatus = [
    { id: 0, title: 'CPU Usage', value: 25, color: 'info', details: '348 Processes. 1/4 Cores.' },
    { id: 1, title: 'Memory Usage', value: 70, color: 'warning', details: '11444GB/16384MB' },
    { id: 2, title: 'SSD 1 Usage', value: 90, color: 'danger', details: '243GB/256GB' }
  ];

  public newTasks = [
    { id: 0, title: 'Upgrade NPM', value: 0, color: 'info' },
    { id: 1, title: 'ReactJS Version', value: 25, color: 'danger' },
    { id: 2, title: 'VueJS Version', value: 50, color: 'warning' },
    { id: 3, title: 'Add new layouts', value: 75, color: 'info' },
    { id: 4, title: 'Angular Version', value: 100, color: 'success' }
  ];

   UserData:any;
   UserDisplayName:any;
   EnvironmentMarkerClass = '';
   EffectiveRoleId = 0;
   IsAdminSession = false;
   CanSwitchRoles = false;
   RoleSwitchOptions: Array<{ id: number; name: string }> = [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Sales Agent' },
    { id: 3, name: 'Coordinator' },
    { id: 4, name: 'Task Owner' }
  ];
  ngOnInit(){

    console.log( this.baseService.environment);

    this.setEnvironmentMarker();
    const userdata = localStorage.getItem('UserInfo') as string;
    if( userdata != 'undefined' && userdata != null){
      let User = JSON.parse(localStorage.getItem('UserInfo') as string );
      User = this.ensureOriginalRole(User);
      this.UserData = User;
      this.EffectiveRoleId = Number(User.effectiveRoleId || User.role_id) || 0;
      this.IsAdminSession = Number(User.actual_role_id || User.role_id) === 1;
      this.RoleSwitchOptions = this.assignedRoleOptions(User);
      this.CanSwitchRoles = this.RoleSwitchOptions.length > 1 || this.IsAdminSession;
      this.setEnvironmentMarker();
      if (this.IsAdminSession) {
        this.loadRoleSwitchOptions();
      }

    }

  }

  private setEnvironmentMarker() {
    const env = String(this.baseService.environment || '').trim().toLowerCase();
    this.UserDisplayName = env ? env.charAt(0).toUpperCase() + env.slice(1) : '';
    this.EnvironmentMarkerClass = env === 'production'
      ? 'environment-marker--production'
      : env === 'sandbox'
        ? 'environment-marker--sandbox'
        : 'environment-marker--default';
  }

  private loadRoleSwitchOptions() {
    this.adminSettings.getRoles().subscribe({
      next: (res: any) => {
        const rawRoles = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.Data)
              ? res.Data
              : Array.isArray(res?.result)
                ? res.result
                : [];

        const roles = rawRoles
          .map((role: any) => ({
            id: Number(role.id ?? role.role_id ?? role.RoleId),
            name: role.name || role.roleName || role.role_name || `Role ${role.id ?? role.role_id ?? role.RoleId}`,
          }))
          .filter((role: any) => role.id)
          .sort((a: any, b: any) => a.id - b.id);

        if (roles.length) {
          this.RoleSwitchOptions = roles;
          this.CanSwitchRoles = this.RoleSwitchOptions.length > 1;
          const user = this.ensureOriginalRole(JSON.parse(localStorage.getItem('UserInfo') || '{}'));
          user.actualRoleName = this.roleName(user.actual_role_id || user.role_id);
          user.effectiveRoleName = this.roleName(user.effectiveRoleId || user.role_id);
          localStorage.setItem('UserInfo', JSON.stringify(user));
        }
      },
      error: () => {
        // Keep built-in fallback labels. Runtime permissions still use role IDs.
      },
    });
  }

  private ensureOriginalRole(user: any) {
    if (!user) return user;
    const assignedRoles = this.assignedRoleOptions(user);
    user.assignedRoles = assignedRoles;
    user.role_ids = assignedRoles.map(role => role.id);
    if (!user.actual_role_id) {
      user.actual_role_id = user.role_id;
      user.actualRoleName = user.roleName || this.roleName(user.role_id);
    }
    if (!user.effectiveRoleId) {
      user.effectiveRoleId = user.role_id;
      user.effectiveRoleName = user.roleName || this.roleName(user.role_id);
    }
    localStorage.setItem('UserInfo', JSON.stringify(user));
    return user;
  }

  private assignedRoleOptions(user: any): Array<{ id: number; name: string }> {
    const rawRoles = Array.isArray(user?.assignedRoles)
      ? user.assignedRoles
      : Array.isArray(user?.AssignedRoles)
        ? user.AssignedRoles
        : [];
    const rolesById = new Map<number, { id: number; name: string }>();
    rawRoles.forEach((role: any) => {
      const id = Number(role.id ?? role.role_id ?? role.RoleId);
      if (id) {
        rolesById.set(id, {
          id,
          name: role.name || role.roleName || role.role_name || this.roleName(id),
        });
      }
    });
    const primaryRoleId = Number(user?.actual_role_id || user?.role_id || 0);
    if (primaryRoleId && !rolesById.has(primaryRoleId)) {
      rolesById.set(primaryRoleId, {
        id: primaryRoleId,
        name: user?.actualRoleName || user?.roleName || this.roleName(primaryRoleId),
      });
    }
    return Array.from(rolesById.values()).sort((a, b) => a.id - b.id);
  }

  roleName(roleId: any): string {
    return this.RoleSwitchOptions.find(role => Number(role.id) === Number(roleId))?.name || 'Unknown';
  }

  switchAdminRole(event: Event) {
    this.switchRoleById(Number((event.target as HTMLSelectElement).value));
  }

  switchAdminRoleById(roleIdValue: any) {
    this.switchRoleById(roleIdValue);
  }

  switchRoleById(roleIdValue: any) {
    const roleId = Number(roleIdValue);
    if (!roleId || roleId === this.EffectiveRoleId) {
      this.EffectiveRoleId = roleId || this.EffectiveRoleId;
      return;
    }
    if (!this.RoleSwitchOptions.some(role => Number(role.id) === roleId)) {
      this.EffectiveRoleId = this.EffectiveRoleId || Number(this.UserData?.effectiveRoleId || this.UserData?.role_id || 0);
      return;
    }
    this.EffectiveRoleId = roleId;
    const user = this.ensureOriginalRole(JSON.parse(localStorage.getItem('UserInfo') || '{}'));

    const roleName = this.roleName(roleId);
    user.role_id = roleId;
    user.roleName = roleName;
    user.effectiveRoleId = roleId;
    user.effectiveRoleName = roleName;

    localStorage.setItem('UserInfo', JSON.stringify(user));
    localStorage.setItem('RoleId', String(roleId));
    localStorage.removeItem('UserPermissions');
    this.clearOrderSessionState();
    this.adminSettings.getMyRolePermissions(roleId).subscribe({
      next: (res: any) => {
        localStorage.setItem('UserPermissions', JSON.stringify(res?.data || []));
        this.reloadForEffectiveRole(roleId);
      },
      error: () => {
        localStorage.setItem('UserPermissions', JSON.stringify([]));
        this.reloadForEffectiveRole(roleId);
      },
    });
  }

  private clearOrderSessionState() {
    localStorage.removeItem('CurrentOrder');
    localStorage.removeItem('EditMode');
    localStorage.removeItem('ReadonlyMode');
    localStorage.removeItem('CoreadonlyMode');
    localStorage.removeItem('IsCoordinator');
    localStorage.removeItem('IsAdmin');
  }

  private reloadForEffectiveRole(roleId: number) {
    window.dispatchEvent(new CustomEvent('om-effective-role-changed', { detail: { roleId } }));
    window.location.reload();
  }
  

  logout() {
    localStorage.removeItem('UserInfo');
    localStorage.removeItem('Token');
    localStorage.removeItem('RoleId');
    localStorage.removeItem('UserId');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
